module.exports = __webpack_public_path__ + "static/media/RAFFLE-TICKET-FRNT.4a56e757.jpg";